import React from 'react';
import SavingsBlock from "./SavingsBlock";
import Assumptions from "./Assumptions";
import Slider from 'rc-slider';
import bandwidthStore from '../store/bandwidth';

const BasicValues = (props) => {
  const wrapperStyle = {  };

  const addCurrencySeparator = (val) => {
    return Math.round(val).toLocaleString(undefined);
  };


  const handleCoresChange = (val) => {
    bandwidthStore.updateCoresSlider(val);
    bandwidthStore.calculateStdCompute(props.state.amount, val, props.state.blockVol);
  };

  const handleBlockVolChange = (val) => {
    bandwidthStore.updateBlockVolSlider(val);
    bandwidthStore.calculateStdCompute(props.state.amount, props.state.cores, val);
  };

  return(
    <div>
      <SavingsBlock state = {props.state} comparisonCompany="Amazon"/>

      <div className="row compareTable ruleBelowRow tcRow">
        <div className="col-xs-8">
          <h5 className="title7 weightBold">&nbsp;</h5>
        </div>
        <div className="col-xs-2 center">
          <h5 className="title7 weightBold azBlue">Cost in AWS (US East)*</h5>
        </div>
        <div className="col-xs-2 totalColumn center totalColumnTop">
          <h5 className="title7 weightBold">Cost in OCI*</h5>
        </div>
      </div>

      {props.state.category === 'own' ?
        <div>
          <div className="row compareTable ruleBelowRow vCenter">
            <div className="col-xs-8">
              <p className="title6">Network Egress</p>
            </div>
            <div className="col-xs-2 azBlue center">
              <p className="body1">${addCurrencySeparator(props.state.awsEgress)}</p>
            </div>
            <div className="col-xs-2 totalColumn center">
              <p className="body1">${addCurrencySeparator(props.state.ociEgress)}</p>
            </div>
          </div>

          <div className="row compareTable ruleBelowRow vCenter">
            <div className="col-xs-8">
              <p className="title6">High IO Block Storage</p>
            </div>
            <div className="col-xs-2 azBlue center">
              <p className="body1">${addCurrencySeparator(props.state.awsBlockStorage)}</p>
            </div>
            <div className="col-xs-2 totalColumn center">
              <p className="body1">${addCurrencySeparator(props.state.ociBlockStorage)}</p>
            </div>
          </div>

          <div className="row compareTable ruleBelowRow vCenter">
            <div className="col-xs-8">
              <p className="title6">Standard Compute</p>
            </div>
            <div className="col-xs-2 azBlue center">
              <p className="body1">${addCurrencySeparator(props.state.awsStdCompute)}</p>
            </div>
            <div className="col-xs-2 totalColumn center">
              <p className="body1">${addCurrencySeparator(props.state.ociStdCompute)}</p>
            </div>
          </div>

          {/* <div className="row compareTable ruleBelowRow vCenter">
            <div className="col-xs-8">
              <p className="title6">GPU/HPC Services</p>
            </div>
            <div className="col-xs-2 azBlue center">
              <p className="body1">${addCurrencySeparator(props.state.awsGPU)}</p>
            </div>
            <div className="col-xs-2 totalColumn center">
              <p className="body1">${addCurrencySeparator(props.state.ociGPU)}</p>
            </div>
          </div> */}

          <div className="row compareTable vCenter">
            <div className="col-xs-8">
              <p className="title6">Total Cost*</p>
            </div>
            <div className="col-xs-2 center azBlue title6">
              <p>${addCurrencySeparator(props.state.totalBYO_AWSCost)}</p>
            </div>
            <div className="col-xs-2 center totalColumn totalColumnBottom title6">
              <p>${addCurrencySeparator(props.state.totalBYO_OCICost)}</p>
            </div>
          </div>

          <div className="row compareTable tcRow">
            <div className="col-xs-6">
            <div className="caption1">DISCLAIMER: The Oracle Cloud Workload Estimator is intended to provide an example of your
            potential savings based on your input. Pricing is based on Oracle's standard published pricing
            for <a href="https://www.oracle.com/cloud/ucpricing.html" target="_blank" rel="noopener noreferrer">Pay As You Go</a> and
            Amazon's standard published on-demand pricing as of May 1, 2020. Oracle Pay As You Go is based on actual usage. This
            calculator tool and its output are intended for information purposes only. Actual savings may vary.</div>
              <Assumptions />
            </div>
            <div className="col-xs-6">
              &nbsp;
            </div>
          </div>

        </div>
        : 
        (props.state.category === 'hpc' ? 
        <div>
          <div className="row compareTable vCenter">
            <div className="col-xs-5">
              <p className="title6">CPUs ({(props.state.coresVal).toLocaleString(undefined)} hours estimated)</p>
            </div>
            <div className="col-xs-5">
                &nbsp;
            </div>
            <div className="col-xs-2 totalColumn">
              &nbsp;
            </div>
          </div>
          <div>
            <div className="row compareTable">
              <div className="col-xs-4">
                <span className="body1">Cores per instance</span>
              </div>
              <div className="col-xs-1 right">
                <span className="body1">{(props.state.cores).toLocaleString(undefined)}</span>
              </div>
              <div className="col-xs-3">
                &nbsp;
              </div>
              <div className="col-xs-2">
                {props.state.cores > 48 ? 
                  <div className="caption1 azBlue">AWS does not offer an instance with more than 48 cores</div>
                  :
                  <>
                  &nbsp;
                  </>
                } 
              </div>
              <div className="col-xs-2 totalColumn">
                &nbsp;
              </div>
            </div>
            <div className="row compareTable ruleBelowRow">
              <div className="col-xs-5">
                <div style={wrapperStyle} >
                  <div className="sliders-marks right">0</div>
                    <Slider min={0} max={48} defaultValue={2} onChange={e => handleCoresChange(e)} />
                  <div className="sliders-marks left">48</div>
                </div>
              </div>
              <div className="col-xs-3">
                &nbsp;
              </div>
              <div className="col-xs-2 center azBlue">
                {props.state.cores > 48 ? 'N/A' : <>${addCurrencySeparator(props.state.awsCores)}</>}
              </div>
              <div className="col-xs-2 center totalColumn">
                ${addCurrencySeparator(props.state.ociCores)}
              </div>
            </div>
          </div> 
          <div className="row compareTable vCenter">
            <div className="col-xs-5">
              <p className="title6">Block Storage ({Math.round(props.state.blockVolVal).toLocaleString(undefined)} GB estimated)</p>
            </div>
            <div className="col-xs-5">
                &nbsp;
            </div>
            <div className="col-xs-2 totalColumn">
              &nbsp;
            </div>
          </div>
          <div>
            <div className="row compareTable">
              <div className="col-xs-4">
                <span className="body1">GB Block Volume per instance (Balanced)</span>
              </div>
              <div className="col-xs-1 right">
                <span className="body1">{Math.round(props.state.blockVol).toLocaleString(undefined)}GB</span>
              </div>
              <div className="col-xs-5">
                &nbsp;
              </div>
              <div className="col-xs-2 totalColumn">
                &nbsp;
              </div>
            </div>
            <div className="row compareTable ruleBelowRow">
              <div className="col-xs-5">
                <div style={wrapperStyle} >
                  <div className="sliders-marks right">50GB</div>
                    <Slider min={50} max={32768} step={50} defaultValue={100} onChange={e => handleBlockVolChange(e)} />
                  <div className="sliders-marks left">32TB</div>
                </div>
              </div>
              <div className="col-xs-3">
                &nbsp;
              </div>
              <div className="col-xs-2 center azBlue">
              {props.state.cores > 48 ? 'N/A' : <>${addCurrencySeparator(props.state.awsBlockVol)}</>}
              </div>
              <div className="col-xs-2 center totalColumn">
                ${addCurrencySeparator(props.state.ociBlockVol)}
              </div>
            </div>
          </div>
          <div className="row compareTable vCenter">
            <div className="col-xs-8">
              <p className="title6">Total Cost*</p>
            </div>
            <div className="col-xs-2 center azBlue title6">
            {props.state.cores > 48 ? 'N/A' : <p>${addCurrencySeparator(props.state.totalComputeAWS)}</p>}
            </div>
            <div className="col-xs-2 center totalColumn totalColumnBottom title6">
              <p>${addCurrencySeparator(props.state.totalComputeOCI)}</p>
            </div>
          </div>

          <div className="row compareTable tcRow">
            <div className="col-xs-6">
            <div className="caption1">DISCLAIMER: The Oracle Cloud Workload Estimator is intended to provide an example of your
            potential savings based on your input. Pricing is based on Oracle's standard published pricing
            for <a href="https://www.oracle.com/cloud/ucpricing.html" target="_blank" rel="noopener noreferrer">Pay As You Go</a> and
            Amazon's standard published on-demand pricing as of May 1, 2020. Oracle Pay As You Go is based on actual usage. This
            calculator tool and its output are intended for information purposes only. Actual savings may vary.</div>
              <Assumptions />
            </div>
            <div className="col-xs-6">
              &nbsp;
            </div>
          </div>

        </div>
        :
        <div className="row compareTable ruleBelowRow vCenter">
          <div className="col-xs-8">
            <p className="title6">{props.name}</p>
          </div>
          <div className="col-xs-2 azBlue center">
            <p className="body1">${addCurrencySeparator(props.state.aws)}</p>
          </div>
          <div className="col-xs-2 totalColumn center">
            <p className="body1">${addCurrencySeparator(props.state.oci)}</p>
          </div>
        </div>
        )
      }
    </div>
  );

};

export default BasicValues;
